import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import EdgeEnd from '../../geomgraph/EdgeEnd';
import Label from '../../geomgraph/Label';
import ArrayList from '../../../../../java/util/ArrayList';
var EdgeEndBuilder = /*#__PURE__*/function () {
  function EdgeEndBuilder() {
    _classCallCheck(this, EdgeEndBuilder);
  }
  _createClass(EdgeEndBuilder, [{
    key: "createEdgeEndForNext",
    value: function createEdgeEndForNext(edge, l, eiCurr, eiNext) {
      var iNext = eiCurr.segmentIndex + 1;
      if (iNext >= edge.getNumPoints() && eiNext === null) return null;
      var pNext = edge.getCoordinate(iNext);
      if (eiNext !== null && eiNext.segmentIndex === eiCurr.segmentIndex) pNext = eiNext.coord;
      var e = new EdgeEnd(edge, eiCurr.coord, pNext, new Label(edge.getLabel()));
      l.add(e);
    }
  }, {
    key: "createEdgeEndForPrev",
    value: function createEdgeEndForPrev(edge, l, eiCurr, eiPrev) {
      var iPrev = eiCurr.segmentIndex;
      if (eiCurr.dist === 0.0) {
        if (iPrev === 0) return null;
        iPrev--;
      }
      var pPrev = edge.getCoordinate(iPrev);
      if (eiPrev !== null && eiPrev.segmentIndex >= iPrev) pPrev = eiPrev.coord;
      var label = new Label(edge.getLabel());
      label.flip();
      var e = new EdgeEnd(edge, eiCurr.coord, pPrev, label);
      l.add(e);
    }
  }, {
    key: "computeEdgeEnds",
    value: function computeEdgeEnds() {
      if (arguments.length === 1) {
        var edges = arguments[0];
        var l = new ArrayList();
        for (var i = edges; i.hasNext();) {
          var e = i.next();
          this.computeEdgeEnds(e, l);
        }
        return l;
      } else if (arguments.length === 2) {
        var edge = arguments[0],
          _l = arguments[1];
        var eiList = edge.getEdgeIntersectionList();
        eiList.addEndpoints();
        var it = eiList.iterator();
        var eiPrev = null;
        var eiCurr = null;
        if (!it.hasNext()) return null;
        var eiNext = it.next();
        do {
          eiPrev = eiCurr;
          eiCurr = eiNext;
          eiNext = null;
          if (it.hasNext()) eiNext = it.next();
          if (eiCurr !== null) {
            this.createEdgeEndForPrev(edge, _l, eiCurr, eiPrev);
            this.createEdgeEndForNext(edge, _l, eiCurr, eiNext);
          }
        } while (eiCurr !== null);
      }
    }
  }]);
  return EdgeEndBuilder;
}();
export { EdgeEndBuilder as default };